// i18n-disable-file statusText 中的中文是字典 key，由消费方使用 $t() 翻译
const logo = 'https://bqq.gtimg.com/qidian/src/themes/blue/common/images/default_avatar.png';
const statusText = {
    1: '审核中',
    2: '审核通过',
    3: '审核不通过',
};
const statusKind = {
    1: 'warning',
    2: 'success',
    3: 'danger',
};
export {
    logo,
    statusText,
    statusKind,
};
